import { render, staticRenderFns } from "./under-construction.vue?vue&type=template&id=62760f29&scoped=true"
import script from "./under-construction.vue?vue&type=script&lang=ts"
export * from "./under-construction.vue?vue&type=script&lang=ts"
import style0 from "./under-construction.vue?vue&type=style&index=0&id=62760f29&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62760f29",
  null
  
)

export default component.exports